@import 'styles/variables';
@import 'styles/mixins';

.title {
  @include xl-semibold;
  padding: 0;
  margin: 0;
}

.title {
  &.v2 {
    @include xxl-semibold;

    @include for-phone-only {
      @include lg-semibold;
    }
  }
}
